// = Libs =
import { FC, useEffect, useMemo, useRef, useState } from 'react';
import clsx from 'clsx';
import ReactSelect from 'react-select';

// = Styles =
import classes from './select.module.scss';
import './react-select.scss';

// = Types =
import { SelectProps } from './select.types';

// = Components =
import SelectDropdownIndicator from './select-dropdown-indicator/select-dropdown-indicator';
import SelectControl from './select-control/select-control';

const Select: FC<SelectProps> = (props) => {
  const {
    options = [],
    name = '',
    placeholder = '',
    className = '',
    isMulti = false,
    required = false,
    value,
    onChange,
    onBlur,
    isId = false,
    isSearchable = false,
    fullWidth = true,
    isDefaultStyle = false,
    styles = undefined,
    controlClass = '',
    disabled = false,
  } = props;

  const foundWithData = useMemo(
    () =>
      options.find((item) => {
        if (value && (typeof value === 'string' || typeof value === 'number')) {
          return item.value === value;
        }
        return false;
      }),
    [value, options]
  );

  const [input] = useState('');
  const [selectValue, setSelectValue] = useState(value);
  const ref = useRef<ReactSelect>(null);

  useEffect(() => {
    setSelectValue(value);
    if (!value) {
      ref.current?.setState((prevState) => ({
        ...prevState,
        value: null,
      }));
    }
  }, [value, options]);

  return (
    <div
      className={clsx({
        [classes.select]: true,
        [classes.selectWidthAuto]: !fullWidth,
      })}>
      <ReactSelect
        ref={ref}
        className={clsx(
          {
            'select--is-multi': isMulti,
          },
          className
        )}
        classNamePrefix={isDefaultStyle ? '' : 'select'}
        options={options}
        placeholder={placeholder}
        isMulti={isMulti}
        name={name}
        value={isId ? foundWithData : selectValue}
        onChange={onChange}
        onBlur={onBlur}
        isSearchable={isSearchable}
        inputValue={isSearchable ? undefined : input}
        onInputChange={isSearchable ? undefined : () => undefined}
        styles={styles}
        isDisabled={disabled}
        components={
          isDefaultStyle
            ? undefined
            : {
                DropdownIndicator: (props) => (
                  <SelectDropdownIndicator
                    iconType={isMulti ? 'plus' : 'dropdown'}
                    addClass={controlClass}
                    {...props}
                  />
                ),
                IndicatorSeparator: (props) => null,
                Control: (props) => (
                  <SelectControl {...props} addClass={controlClass} />
                ),
              }
        }
      />
    </div>
  );
};

export default Select;
